import { render } from "./MarketGroups.vue?vue&type=template&id=35cab94a"
import script from "./MarketGroups.vue?vue&type=script&lang=js"
export * from "./MarketGroups.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__